import loader from 'sass-loader';
import configuration from '../../../api/configuration';
import Swal from 'sweetalert2';
import PageLoader from '../../Common/PageLoader';

export const actualizarFactorIntegracion = async () => {

   try {
      const {data} = await configuration.post('ActualizarFactorIntegracion');
      Swal.fire({
         icon: 'success',
         title: 'Éxito',
         text: 'Factor de integración actualizado correctamente.'
      });
      return data;
   }catch (error) {
      console.error('Error in actualizarFactorIntegracion:', error);
      Swal.fire({
         icon: 'error',
         title: 'Oops...',
         text: 'Ocurrió un error al intentar actualizar el factor de integración de empleados.' 
      })
   }

}